export const suscription = {
  p1: `Gérez les détails de votre forfait actuel et explorez les options pour améliorer ou modifier votre abonnement.`,
  p2: `Forfait annuel`,
  p3: `Forfait mensuel`,
  p4: `Actif jusqu'au`,
  p5: `Par chambre et par mois`,
  p6: `Par hébergement et par mois`,
  p7: `Nombre d'occupations`,
  p8: `Par occupation et par mois`,
  p9: `Mettre à jour l'abonnement`,
  p10: `Services actifs`,
  p11: `Actif`,
  p12: `Inactif`,
  p13: `Invitez vos clients à effectuer leur check-in via WhatsApp, en le programmant avant leur arrivée à l'hébergement.`,
  p14: `Avis`,
  p15: `Invitez vos clients à évaluer leur expérience et améliorez la réputation de votre hébergement grâce à des avis positifs.`,
  p16: `Accès à distance`,
  p17: `Enregistrez et gérez les chambres équipées de serrures connectées. Configurez les codes d'accès à fournir aux clients.`,
  p18: `Vérification d'identité`,
  p19: `Nous vérifions l'identité des clients en comparant la photo de leur pièce d'identité ou de leur passeport avec un selfie en temps réel.`,
  p20: `Gérer l'abonnement et les moyens de paiement`,
  p21: `Ajoutez ou supprimez des cartes selon vos besoins`,
  p22: `Votre abonnement actuel est gratuit`,
  p23: `Améliorez votre abonnement pour accéder aux fonctionnalités avancées.`,
  p24: `Votre abonnement gratuit expire dans`,
  p25: `jour`,
  p26: `jours`,
  p27: `Ne perdez pas l'accès aux fonctionnalités avancées ; améliorez votre abonnement maintenant`,
  p28: `Personnalisez votre forfait avec des services supplémentaires`,
  p29: `occupation`,
  p30: `mois`,
  p31: `Avis`,
  p32: `Accès à distance`,
  p33: `tente`,
  p34: `villa`,
  p35: `Vérification d'identité`,
  p36: `OCCUPATION TOTALE`,
  p37: `L'occupation totale correspond à la capacité maximale de personnes autorisées dans l'ensemble de vos appartements, par exemple (si vous sélectionnez 5 appartements, votre occupation totale peut être de 20 places). Indiquer l'occupation totale nous aide à gérer votre abonnement avec précision et à respecter les réglementations de sécurité.`,
  p38: `L'occupation totale correspond à la capacité maximale de personnes autorisées dans votre villa, par exemple (si vous sélectionnez 5 appartements, votre occupation totale peut être de 20 places). Indiquer l'occupation totale nous aide à gérer votre abonnement avec précision et à respecter les réglementations de sécurité.`,
  p39: `L'occupation totale correspond à la capacité maximale de personnes autorisées dans votre hôtel - auberge, par exemple (si vous sélectionnez 5 appartements, votre occupation totale peut être de 20 places). Indiquer l'occupation totale nous aide à gérer votre abonnement avec précision et à respecter les réglementations de sécurité.`,
  p40: `L'occupation totale correspond à la capacité maximale de personnes autorisées dans votre camping, par exemple (si vous sélectionnez 5 appartements, votre occupation totale peut être de 20 places). Indiquer l'occupation totale nous aide à gérer votre abonnement avec précision et à respecter les réglementations de sécurité.`,
  p41: `Vous devez saisir l'occupation totale de vos logements.`,
  p42: `WACheckin WhatsApp`,
  p43: `Votre WhatsApp Business`,
  p44: `par occupation/mois`,
  p45: `par chambre/mois`,
  p46: `Annuel`,
  p47: `Activer l'abonnement`,
  p48: `Mettre à jour l'abonnement`,
  p49: `Abonnement sélectionné`,
  p50: `Nombre de`,
  p51: `chambre`,
  p52: `hébergement`,
  p53: `Prix mensuel par`,
  p54: `chambres`,
  p55: `hébergements`,
  p56: `Nombre d'occupations sélectionné`,
  p57: `Prix mensuel par`,
  p58: `occupation`,
  p59: `Type d'abonnement`,
  p60: `Annuel`,
  p61: `Mensuel`,
  p62: `Services supplémentaires :`,
  p63: `Aucun service ajouté`,
  p64: `Il est recommandé d'ajouter le service WhatsApp`,
  p65: `Avis`,
  p66: `Total à payer`,
  p67: `Procéder au paiement`,
  p68: `Mettre à jour l'abonnement`,
  p69: "ChatBot",

  p70: `Abonnement`,
  p71: `Actif`,
  p72: `Services supplémentaires facultatifs`,

  p73: `Avez-vous de nouveaux logements à gérer ?`,

  p74: `Détails de votre mise à jour et de vos nouveaux services`,
  p75: `Les frais pour les services ou logements supplémentaires seront appliqués au prorata, en tenant compte des jours restants du mois dans votre abonnement actuel.`,
  p76: `Vous ne payez ainsi que pour la durée d'utilisation exacte jusqu'au renouvellement de votre forfait.`,

  p77: `Logements ajoutés`,
  p78: `Services supplémentaires`,
  p79: `Accès à distance`,
  p80: `ChatBot IA`,
  p81: `Prix`,
  p82: `Annuel`,
  p83: `Mensuel`,
  p84: `Mettre à jour l'abonnement`,

  p85: `Logements souscrits`,
  p86: `Services supplémentaires`,
  p87: `Aucun service supplémentaire souscrit`,
  p88: `ChatBot IA`,
  p89: `Accès à distance`,

  p90: `Inclus dans le forfait`,

  p91: `Prix par an`,
  p92: `Prix par mois`,

  p93: `Statut`,
  p94: `Actif`,
  p95: `Expire`,

  p96: `Enregistrez et gérez les chambres équipées de serrures connectées. Configurez les codes d'accès qui seront fournis aux clients.`,

  p97: `ChatBot IA`,
  p98: `Ajoutez le service de chatbot alimenté par l'IA et automatisez les demandes de vos clients rapidement et efficacement.`,

  p99: `Êtes-vous sûr de vouloir poursuivre le processus ?`,
  p100: `Mettre à jour l'abonnement`,

  p101: ``,
  p102: ``,
  p103: ``,
  p104: ``,
  p105: ``,
  p106: ``,
  p107: ``,
  p108: ``,
  p109: ``,
  p110: ``,
  p111: ``,
  p112: ``,
  p113: ``,
  p114: ``,
  p115: ``,

};
